import React from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";

const FormBuilder = () => {
  const data = [
    {
      id: "1737810072095",
      type: "text",
      label: "Text Field",
      placeholder: "Enter Text",
    },
    {
      id: "1737810073711",
      type: "password",
      label: "Password Field",
      placeholder: `Enter Password`,
    },
    {
      id: "1737810074208",
      type: "email",
      label: "Email Field",
      placeholder: "Enter Email",
    },
    {
      id: "1737810074776",
      type: "checkbox",
      label: "Checkbox Field",
      text: "Checkbox text",
    },
    {
      id: "1737810075151",
      type: "select",
      label: "Select Field",
      options: [
        { label: "Option 1", value: "option1" },
        { label: "Option 2", value: "option2" },
        { label: "Option 3", value: "option3" },
      ],
    },
  ];

  const getFieldName = (label) => label.toLowerCase().replace(/\s+/g, "_");

  const validationSchema = Yup.object(
    data.reduce((schema, field) => {
      const fieldName = getFieldName(field.label);
      if (
        field.type === "text" ||
        field.type === "email" ||
        field.type === "password"
      ) {
        schema[fieldName] = Yup.string().required(`${field.label} is required`);
      } else if (field.type === "checkbox") {
        schema[fieldName] = Yup.boolean();
      } else if (field.type === "select") {
        schema[fieldName] = Yup.string().required(`${field.label} is required`);
      }
      return schema;
    }, {})
  );

  const initialValues = data.reduce((values, field) => {
    const fieldName = getFieldName(field.label);
    values[fieldName] = field.type === "checkbox" ? false : "";
    return values;
  }, {});

  const handleSubmit = (values, { setSubmitting, resetForm }) => {
    const Form = new FormData();
    Object.entries(values).forEach(([key, value]) => {
      Form.append(key, value);
    });

    console.log(values);
  };

  return (
    <div className="col-md-4 col-sm-4 col-xs-12">
      <div className="left-head-blog right-side">
        <div className="left-blog-page">
          <div className="left-blog blog-category">
            <div className="comment-respond">
              <h3 className="comment-reply-title">Leave a Reply </h3>
              <div className="row">
                <div className="col-lg-4=12 col-md-12 col-sm-12 col-xs-12">
                  <Formik
                    initialValues={initialValues}
                    validationSchema={validationSchema}
                    onSubmit={handleSubmit}
                  >
                    {({ isSubmitting }) => (
                      <Form>
                        {data?.map((field) => {
                          const fieldName = getFieldName(field.label);
                          return (
                            <div key={field.id} className="form-group">
                              <label>
                                {field.label !== "Checkbox Field" &&
                                  field.label}
                              </label>
                              {field.type === "select" ? (
                                <Field
                                  as="select"
                                  name={fieldName}
                                  className="form-select"
                                >
                                  <option value="">Select an option</option>
                                  {field.options.map((option) => (
                                    <option
                                      key={option.value}
                                      value={option.value}
                                    >
                                      {option.label}
                                    </option>
                                  ))}
                                </Field>
                              ) : field.type === "checkbox" ? (
                                <div className="mb-0">
                                  <Field
                                    type="checkbox"
                                    name={fieldName}
                                    className="me-2"
                                  />
                                  <span className="text-white">
                                    {field.text}
                                  </span>
                                </div>
                              ) : (
                                <Field
                                  type={field.type}
                                  name={fieldName}
                                  placeholder={field.placeholder}
                                  className="form-control"
                                />
                              )}
                              <ErrorMessage
                                name={fieldName}
                                component="div"
                                className="text-danger"
                              />
                            </div>
                          );
                        })}

                        <button type="submit" className="submit-btn anti-btn">
                          {isSubmitting ? "Submitting..." : "Submit"}
                        </button>
                      </Form>
                    )}
                  </Formik>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FormBuilder;
